import { Screen, IProps } from "./screen";
import { Styled as StyledScreen } from './styled'

export { Screen, StyledScreen, IProps }